const DashCard = ({ title, cornerContent, children, id }) => {
  return (
    <div className="dash-card" id={id}>
      <h4 className="italic-subtitle">
        <span>{title}</span>
        {cornerContent}
      </h4>
      {children}
    </div>
  );
};

export default DashCard;
